// Short-lived display lookups only. Never use for validation or write decisions.
export function createReadCache({ttl = 30000, maxEntries = 64, now = Date.now} = {}) {
  const entries = new Map();
  return {
    clear() {entries.clear();},
    read(key, load) {
      const cached = entries.get(key);
      if (cached && (cached.pending || now() < cached.expires)) return cached.promise;
      if (entries.size >= maxEntries) entries.delete(entries.keys().next().value);
      const entry = {pending: true, expires: 0};
      entry.promise = Promise.resolve().then(load).then(value => {
        entry.pending = false;entry.expires = now() + ttl;
        if (ttl === 0 && entries.get(key) === entry) entries.delete(key);
        return value;
      }, error => {if (entries.get(key) === entry) entries.delete(key);throw error;});
      entries.set(key, entry);return entry.promise;
    },
  };
}
export const suggestionReads = createReadCache({ttl: 0});
